import React from 'react';
import { useSelector } from 'react-redux';
import DynamicLink from '../../components/dynamic_link';
import hotInsuranceLogoPath from '../../assets/logos/hot-insurance-logo.svg';
import phoneIconPath from '../../assets/icons/phone-icon.svg';
import './index.scss';

const InsuranceFooter = () => {
    const deviceState = useSelector((store) => store.deviceState.device);
    const insurancePage = useSelector((store) => store.insurancePage);

    const isMobileOrTablet = (deviceState === 'mobile' || deviceState === 'tablet');

    const footerMenu = Object.values(insurancePage?.footer || {});

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-logo-container">
                    <img src={hotInsuranceLogoPath} alt="Hot Insurance" className="footer-logo-element" />

                    <div className="footer-logo-content-container">
                        <p className="footer-logo-content-paragraph footer-logo-content-paragraph_primary">
                            {insurancePage?.general?.call_us_message}
                        </p>

                        <p className="footer-logo-content-paragraph footer-logo-content-paragraph_secondary">
                            <img src={phoneIconPath} alt="Phone Icon" className="footer-logo-content-icon" />

                            {isMobileOrTablet ? (
                                <a href={`tel:*${insurancePage?.general?.short_tel}`}>
                                    {`${insurancePage?.general?.short_tel}*`}
                                </a>
                            ) : (
                                `${insurancePage?.general?.short_tel}*`
                            )}
                        </p>
                    </div>
                </div>

                <ul className="footer-links-list">
                    {footerMenu.map((linkData) => (
                        <li key={linkData?.id} className="links-list-item">
                            <DynamicLink
                                data={linkData?.link}
                                className="footer-link-element"
                            >
                                {linkData?.title}
                            </DynamicLink>
                        </li>
                    ))}
                </ul>

                <p className="footer-copyright-message">
                    {insurancePage?.general?.copyright_message}
                </p>
            </div>
        </footer>
    );
};

export default InsuranceFooter;
